"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylingExample = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var ColorPreview_1 = require("./ColorPreview");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
exports.StylingExample = function (props) {
    var name = props.name, colors = props.colors, onClick = props.onClick;
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement("div", { className: "gd-styling-example" },
        react_1.default.createElement("div", { className: "gd-styling-example-label" },
            react_1.default.createElement("div", { className: "gd-styling-example-label-name" }, name),
            react_1.default.createElement("div", { className: "gd-styling-example-label-action s-gd-styling-example-label-action", onClick: onClick }, intl.formatMessage({ id: "stylingEditor.dialog.example.paste" }))),
        react_1.default.createElement(ColorPreview_1.ColorPreview, { className: "color-preview-small", colors: colors })));
};
//# sourceMappingURL=StylingExample.js.map